/* Celestial Projectors — interactions: starfield, reveals, mood finder, read-more, sticky add-to-cart */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Starfield canvas ---------- */
  function Starfield(canvas) {
    this.c = canvas;
    this.ctx = canvas.getContext('2d');
    this.stars = [];
    this.shooting = [];
    this.px = 0; this.py = 0; this.tx = 0; this.ty = 0;
    this.running = false;
    this.density = parseFloat(canvas.getAttribute('data-density') || '1');
    this.resize = this.resize.bind(this);
    this.loop = this.loop.bind(this);
    this.resize();
    window.addEventListener('resize', this.resize, { passive: true });
    var self = this;
    canvas.parentElement.addEventListener('pointermove', function (e) {
      var r = canvas.getBoundingClientRect();
      self.tx = ((e.clientX - r.left) / r.width - 0.5) * 2;
      self.ty = ((e.clientY - r.top) / r.height - 0.5) * 2;
    }, { passive: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { en.isIntersecting ? self.start() : self.stop(); });
      }).observe(canvas);
    } else { this.start(); }
    document.addEventListener('visibilitychange', function () { document.hidden ? self.stop() : self.start(); });
  }
  Starfield.prototype.resize = function () {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = this.c.clientWidth, h = this.c.clientHeight;
    this.w = w; this.h = h; this.dpr = dpr;
    this.c.width = w * dpr; this.c.height = h * dpr;
    this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    var count = Math.round((w * h) / 2600 * this.density);
    count = Math.max(120, Math.min(count, 700));
    var palette = ['255,255,255', '214,204,255', '190,232,255', '255,226,246', '255,241,214'];
    this.stars = [];
    for (var i = 0; i < count; i++) {
      var z = Math.random();
      this.stars.push({
        x: Math.random() * w, y: Math.random() * h, z: z,
        r: z * 1.5 + 0.25, a: Math.random() * 0.6 + 0.3,
        tw: Math.random() * 0.02 + 0.004, ph: Math.random() * Math.PI * 2,
        c: palette[(Math.random() * palette.length) | 0]
      });
    }
    if (reduceMotion) this.draw(0);
  };
  Starfield.prototype.start = function () { if (this.running || reduceMotion) return; this.running = true; this.last = performance.now(); requestAnimationFrame(this.loop); };
  Starfield.prototype.stop = function () { this.running = false; };
  Starfield.prototype.loop = function (t) {
    if (!this.running) return;
    this.draw(t);
    requestAnimationFrame(this.loop);
  };
  Starfield.prototype.draw = function (t) {
    var ctx = this.ctx, w = this.w, h = this.h;
    this.px += (this.tx - this.px) * 0.04; this.py += (this.ty - this.py) * 0.04;
    ctx.clearRect(0, 0, w, h);
    for (var i = 0; i < this.stars.length; i++) {
      var s = this.stars[i];
      var tw = reduceMotion ? 1 : (Math.sin(t * s.tw * 0.06 + s.ph) * 0.35 + 0.65);
      var x = s.x + this.px * s.z * 14, y = s.y + this.py * s.z * 10 - (reduceMotion ? 0 : (t * 0.004 * s.z) % h);
      if (y < 0) y += h;
      ctx.globalAlpha = s.a * tw;
      ctx.fillStyle = 'rgb(' + s.c + ')';
      ctx.beginPath(); ctx.arc(x, y, s.r, 0, 6.2832); ctx.fill();
      if (s.r > 1.45) {
        ctx.globalAlpha = s.a * tw * 0.25;
        ctx.beginPath(); ctx.arc(x, y, s.r * 3.2, 0, 6.2832); ctx.fill();
      }
    }
    ctx.globalAlpha = 1;
    if (reduceMotion) return;
    if (Math.random() < 0.006 && this.shooting.length < 2) {
      this.shooting.push({ x: Math.random() * w * 0.8 + w * 0.2, y: Math.random() * h * 0.4, vx: -(Math.random() * 6 + 6), vy: Math.random() * 3 + 2.5, life: 1 });
    }
    for (var k = this.shooting.length - 1; k >= 0; k--) {
      var m = this.shooting[k];
      var g = ctx.createLinearGradient(m.x, m.y, m.x - m.vx * 14, m.y - m.vy * 14);
      g.addColorStop(0, 'rgba(255,255,255,' + m.life + ')');
      g.addColorStop(1, 'rgba(205,188,255,0)');
      ctx.strokeStyle = g; ctx.lineWidth = 1.6; ctx.lineCap = 'round';
      ctx.beginPath(); ctx.moveTo(m.x, m.y); ctx.lineTo(m.x - m.vx * 14, m.y - m.vy * 14); ctx.stroke();
      m.x += m.vx; m.y += m.vy; m.life -= 0.012;
      if (m.life <= 0 || m.x < -200 || m.y > h + 200) this.shooting.splice(k, 1);
    }
  };

  function initStarfields(root) {
    (root || document).querySelectorAll('canvas[data-cp-starfield]').forEach(function (c) {
      if (c.__cp) return; c.__cp = new Starfield(c);
    });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.cp-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduceMotion) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Mood finder tabs ---------- */
  function initMood(root) {
    (root || document).querySelectorAll('[data-cp-mood]').forEach(function (wrap) {
      if (wrap.__cp) return; wrap.__cp = true;
      var tabs = wrap.querySelectorAll('[role=tab]');
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(i); });
        tab.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
            select(n); tabs[n].focus();
          }
        });
      });
      function select(n) {
        tabs.forEach(function (t, j) {
          var on = j === n;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var p = document.getElementById(t.getAttribute('aria-controls'));
          if (p) p.hidden = !on;
        });
      }
    });
  }

  /* ---------- Read more ---------- */
  function initReadMore(root) {
    (root || document).querySelectorAll('[data-cp-readmore]').forEach(function (w) {
      if (w.__cp) return; w.__cp = true;
      var prose = w.querySelector('.cp-prose');
      if (!prose || prose.scrollHeight < 520) { w.setAttribute('data-collapsed', 'false'); var b = w.querySelector('.cp-readmore__btn'); if (b) b.remove(); return; }
      var btn = w.querySelector('.cp-readmore__btn');
      if (btn) btn.addEventListener('click', function () {
        var c = w.getAttribute('data-collapsed') === 'true';
        w.setAttribute('data-collapsed', c ? 'false' : 'true');
        btn.setAttribute('aria-expanded', c ? 'true' : 'false');
        if (!c) w.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ---------- Sticky add to cart (product pages) ---------- */
  function initStickyATC() {
    var bar = document.querySelector('[data-cp-sticky-atc]');
    if (!bar || bar.__cp) return; bar.__cp = true;
    var form = document.querySelector('product-info form[action*="/cart/add"], .product form[action*="/cart/add"]');
    var submit = form && form.querySelector('[type=submit][name=add]');
    if (!submit) { bar.remove(); return; }
    var btn = bar.querySelector('button');
    var priceEl = bar.querySelector('[data-cp-sticky-price]');
    btn.addEventListener('click', function () {
      if (submit.disabled) { submit.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      submit.click();
    });
    function sync() {
      btn.disabled = submit.disabled;
      var label = submit.querySelector('span');
      btn.textContent = label ? label.textContent.trim() : btn.textContent;
      var p = document.querySelector('.product__info-container .price-item--sale, .product__info-container .price__regular .price-item--regular');
      if (p && priceEl) priceEl.textContent = p.textContent.trim();
    }
    sync();
    new MutationObserver(sync).observe(submit, { attributes: true, childList: true, subtree: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var below = en.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', !en.isIntersecting && below);
        });
      }).observe(submit);
    }
  }

  function initAll(root) { initStarfields(root); initReveal(root); initMood(root); initReadMore(root); initStickyATC(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
